import React, { useState, useEffect } from 'react';
import { useHRMS } from '../context/HRMSContext.jsx';
import api from '../services/api.js';
import DatePicker from '../components/DatePicker.jsx';
import Message from '../components/Message.jsx';

function Workers() {
  const { state, loadWorkers } = useHRMS();
  const [showForm, setShowForm] = useState(false);
  const [editingWorker, setEditingWorker] = useState(null);
  const emptyForm = {
    name: '',
    email: '',
    department: '',
    position: '',
    salary: '',
    joinDate: '',
    shiftId: ''
  };
  const [formData, setFormData] = useState(emptyForm);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        shiftId: formData.shiftId ? parseInt(formData.shiftId, 10) : null
      };
      if (editingWorker) {
        await api.workers.update(editingWorker.id, payload);
        setMessage({ text: 'Worker updated successfully!', type: 'success' });
      } else {
        await api.workers.create(payload);
        setMessage({ text: 'Worker added successfully!', type: 'success' });
      }
      loadWorkers();
      setFormData(emptyForm);
      setShowForm(false);
      setEditingWorker(null);
    } catch (error) {
      console.error('Error saving worker:', error);
      setMessage({ text: `Error saving worker: ${error.message || 'Unknown error'}`, type: 'error' });
    }
  };

  const handleEdit = (worker) => {
    setEditingWorker(worker);
    setFormData({
      ...worker,
      shiftId: worker.shiftId ? String(worker.shiftId) : ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.workers.delete(id);
        loadWorkers();
      } catch (error) {
        console.error('Error deleting worker:', error);
      }
    }
  };

  const getShiftName = (shiftId) => {
    if (!shiftId || !Array.isArray(state.shifts)) return '';
    const numericId = parseInt(shiftId, 10);
    const shift = state.shifts.find(shift => parseInt(shift.id, 10) === numericId);
    return shift ? (shift.shiftName || shift.name || shift.shift_name || `Shift ${shift.id}`) : '';
  };

  // Load workers data when component mounts
  useEffect(() => {
    loadWorkers();
  }, [loadWorkers]);



  return (
    <div className="Workers">
      {message.text && (
        <Message
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: '', type: '' })}
        />
      )}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Workers ({Array.isArray(state.workers) ? state.workers.length : 0})</h2>
        <div>
          <button className="btn btn-outline-secondary me-2" onClick={loadWorkers} title="Refresh">
            🔄 Refresh
          </button>
          <button className="btn btn-primary" onClick={() => {
            setShowForm(true);
          }}>
            Add Worker
          </button>
        </div>
      </div>

      {showForm && (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editingWorker ? 'Edit Worker' : 'Add New Worker'}</h5>
                <button type="button" className="btn-close" onClick={() => {
                  setShowForm(false);
                  setEditingWorker(null);
                  setFormData(emptyForm);
                }}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Email *</label>
                      <input
                        type="email"
                        className="form-control"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Department *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.department}
                        onChange={(e) => setFormData({ ...formData, department: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Position *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.position}
                        onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Salary *</label>
                      <input
                        type="number"
                        className="form-control"
                        value={formData.salary}
                        onChange={(e) => setFormData({ ...formData, salary: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Join Date *</label>
                      <DatePicker
                        value={formData.joinDate}
                        onChange={(date) => setFormData({ ...formData, joinDate: date })}
                        placeholder="Select joining date"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Shift *</label>
                      <select
                        className="form-control"
                        value={formData.shiftId}
                        onChange={(e) => setFormData({ ...formData, shiftId: e.target.value })}
                     required >
                        <option value="">Select Shift</option>
                        {(Array.isArray(state.shifts) ? state.shifts : []).map(shift => (
                          <option key={shift.id} value={shift.id}>
                            {shift.shiftName || shift.name || `Shift ${shift.id}`}
                          </option>
                         
                        ))} 
                      </select>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-success">
                    Save
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => {
                    setShowForm(false);
                    setEditingWorker(null);
                    setFormData(emptyForm);
                  }}>
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Department</th>
                  <th>Position</th>
                  <th>Shift</th>
                  <th>Salary</th>
                  <th>Join Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(state.workers) ? state.workers.map(worker => (
                  <tr key={worker.id}>
                    <td>{worker.name}</td>
                    <td>{worker.email}</td>
                    <td>{worker.department}</td>
                    <td>{worker.position}</td>
                    <td>{getShiftName(worker.shiftId) || '-'}</td>
                    <td>₹{worker.salary}</td>
                    <td>{worker.joinDate}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary me-2" onClick={() => handleEdit(worker)}>
                        Edit
                      </button>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(worker.id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                )) : <tr><td colSpan="8">No workers found</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Workers;